var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24C18.6274 24 24 18.6274 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM18.5 15.5C18.5 16.3284 17.8284 17 17 17H7C6.17157 17 5.5 16.3284 5.5 15.5V10.761C5.49945 10.67 5.5486 10.5859 5.62817 10.5418C5.70775 10.4976 5.80507 10.5004 5.882 10.549L10.807 13.627C11.5374 14.0804 12.4617 14.0804 13.192 13.627L18.117 10.549C18.194 10.5004 18.2914 10.4977 18.371 10.542C18.4505 10.5862 18.4999 10.67 18.5 10.761V15.5ZM12.4 12.355L18.465 8.563H18.469C18.4889 8.5482 18.5004 8.52477 18.5 8.5C18.5 7.67157 17.8284 7 17 7H7C6.17157 7 5.5 7.67157 5.5 8.5C5.50058 8.52652 5.51552 8.55064 5.539 8.563L11.605 12.355C11.8485 12.5061 12.1565 12.5061 12.4 12.355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeCircle);
export default __webpack_public_path__ + "static/media/envelopeCircle.2e890eb8.svg";
export { ForwardRef as ReactComponent };